import React, { useState } from 'react';
import s from './CalendarModal.module.scss';
import { CalendarEvent, addToGoogleCalendar, addToOutlookCalendar, addToAppleCalendar } from 'components/utils/calendarExport';

interface CalendarModalProps {
    event: CalendarEvent;
    onClose: () => void;
}

const CalendarModal: React.FC<CalendarModalProps> = ({ event, onClose }) => {
    const [showSuccess, setShowSuccess] = useState(false);

    const handleGoogleCalendar = () => {
        addToGoogleCalendar(event);
        onClose();
    };

    const handleOutlookCalendar = () => {
        addToOutlookCalendar(event);
        onClose();
    };

    const handleAppleCalendar = () => {
        addToAppleCalendar(event);
        setShowSuccess(true);
        setTimeout(() => {
            setShowSuccess(false);
            onClose();
        }, 2000);
    };

    const handleOverlayClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className={s.overlay} onClick={handleOverlayClick}>
    <div className={s.modal}>
    <div className={s.header}>
    <div className={s.title}>Add to Calendar</div>
    <button className={s.closeButton} onClick={onClose}>×</button>
    </div>

    <div className={s.options}>
    <div className={s.option} onClick={handleGoogleCalendar}>
    <svg className={s.icon} viewBox="0 0 24 24" fill="none">
    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
        </svg>
        <div className={s.optionContent}>
    <div className={s.optionTitle}>Google Calendar</div>
    <div className={s.optionDescription}>Opens in browser</div>
        </div>
        </div>

        <div className={s.option} onClick={handleOutlookCalendar}>
    <svg className={s.icon} viewBox="0 0 24 24" fill="none">
    <path d="M7 4c-1.657 0-3 1.343-3 3v10c0 1.657 1.343 3 3 3h10c1.657 0 3-1.343 3-3V7c0-1.657-1.343-3-3-3H7z" fill="#0078D4"/>
    <path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" fill="white"/>
        </svg>
        <div className={s.optionContent}>
    <div className={s.optionTitle}>Outlook</div>
        <div className={s.optionDescription}>Opens in browser</div>
        </div>
        </div>

        <div className={s.option} onClick={handleAppleCalendar}>
    <svg className={s.icon} viewBox="0 0 24 24" fill="none">
    <rect x="3" y="4" width="18" height="18" rx="2" fill="#FF3B30"/>
    <text x="12" y="16" fontSize="12" fontWeight="bold" fill="white" textAnchor="middle">31</text>
        </svg>
        <div className={s.optionContent}>
    <div className={s.optionTitle}>Apple Calendar</div>
    <div className={s.optionDescription}>Downloads .ics file</div>
    </div>
    </div>
    </div>

    {showSuccess && (
        <div className={s.successMessage}>
            File downloaded! Open it to add to your calendar.
    </div>
    )}
    </div>
    </div>
);
};

export default CalendarModal;